<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img src="https://www.grupokla.com.br/joaopessoa/_images/logo.png" width="230px">
              </span>
              <span class="login-title">
                <p>Confirme sua inscrição</p>
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Selecione o evento que você deseja participar:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="inscricao.eventoId" :items="eventos" item-text="nome" item-value="id" color="#00695C"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha seus dados:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg5>
                      <v-text-field light label="CPF" color="#00695C" outlined v-mask="mask" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="inscricao.cpf"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg5>
                      <v-text-field light label="EMAIL" color="#00695C" outlined hide-details dense required v-model="inscricao.email"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-btn dark block @click="localizarInscricao">BUSCAR</v-btn>
                    </v-flex>
                    <v-flex xs10 sm10 lg12 v-if="inscricaoLocalizada">
                      <br>
                    </v-flex>
                    <v-flex xs12 sm12 lg6 v-if="inscricaoLocalizada">
                      <v-text-field light v-model="inscricao.nome" label="NOME COMPLETO" single-line outlined color="#00695C" dense hide-details required disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6 v-if="inscricaoLocalizada">
                      <v-text-field light v-model="inscricao.nomeCracha" label="NOME CRACHÁ" single-line outlined color="#00695C" dense hide-details required disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="inscricaoLocalizada">
                      <v-text-field light v-model="inscricao.empresa" label="EMPRESA" single-line outlined color="#00695C" dense hide-details required disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="inscricaoLocalizada">
                      <v-text-field light v-model="inscricao.cargo" label="CARGO" single-line outlined color="#00695C" dense hide-details required disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="inscricaoLocalizada">
                      <v-select outlined dense v-model="inscricao.infoVacina" :items="doses" hide-details item-text="text" item-value="value" color="#00695C" label="SOBRE A VACINA"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center; border: 1px solid; border-color: #c2c2c2; border-radius: 5px; background-color: white; padding: 20px; margin-top: 4px" v-if="inscricaoLocalizada">
                      <p class="form-titulo" style="font-size: 15px">COMPROVANTE VACINAL</p>
                      <v-btn v-if="inscricao.arquivoComprovanteVacinal == ''" @click="uploadComprovanteVacinal = true" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                      <img v-else width="120px" :src="inscricao.arquivoComprovanteVacinal" alt="arquivoComprovanteVacinal" @click="uploadComprovanteVacinal = true" />
                      <br>
                      <p style="margin-top: 5px">Devido o decreto nº 41.979 publicado em 30/11/2021, faz-se necessária a apresentação do comprovante de vacinação contra a COVID-19 com esquema vacinal completo para ingressar nos eventos sociais e/ou corporativos.</p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px" v-if="inscricaoLocalizada">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large @click="realizarInscricao">Confirmar Inscrição</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-btn dark depressed block color="#E53935" style="border-radius: 7px;" large @click="solicitaCancelamento">Solicitar Cancelamento</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
              <v-card-actions style="text-align: center;">
                <v-container fluid grid-list-md>
                  <p>
                    <em>Precisando de ajuda? Contate-nos pelo WhatsApp <a style="text-decoration: none" href="https://wa.me/5583996760127?text=Olá%20estou%20precisando%20de%20ajuda%20na%20inscrição">(83) 99676-0127</a>.</em>
                  </p>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logo.webp" width="130px">
          </a>
        </div>

        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-text style="text-align: center;padding:0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                  </v-col>
                  <!-- <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{msgResultado}}</p>
                  </v-col> -->
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#EF6C00">Guarde esse código ou print essa imagem, será necessário para a sua identificação no dia do evento.</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{eventoSelecionado}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="background-color: #D32F2F;color: white;">O uso de máscara é obrigatório.</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">SEU CÓDIGO É: <span style="color:#EF6C00">{{inscricao.cod_incricao}}</span></p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <qrcode-vue :value="inscricao.cod_incricao" :size="100" level="H"></qrcode-vue>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="closeDialog">fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">Solicitação de Cancelamento</span>
            </v-card-title>
            <v-card-text style="text-align: center;padding:0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">CPF : {{inscricao.cpf}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{eventoSelecionado}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="background-color: #D32F2F;color: white;">Confirme a sua solicitação de cancelamento</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="realizarCancelamento">confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="uploadComprovanteVacinal" max-width="550px" max-height="300px" persistent> 
          <v-card style="border-radius: 10px;">
            <v-container grid-list-md>
              <v-layout row wrap justify-center>
                <v-container fill-height fluid pa-1 justify-center>
                  <vueAnkaCropper
                    :options="{
                      aspectRatio: 0,
                      closeOnSave: true,
                      cropArea: 'box',
                      croppedHeight: 500,
                      croppedWidth: 500,
                      cropperHeight: false,
                      dropareaMessage: 'Insira aqui uma imagem do seu comprovante vacinal',
                      frameLineDash: [0,0],
                      frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      handleFillColor: 'rgba(255, 255, 255, 0.2)',
                      handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                      handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                      handleSize: 10,
                      handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      layoutBreakpoint: 500,
                      maxCropperHeight: 768,
                      maxFileSize: 8000000,
                      overlayFill: 'rgba(0, 0, 0, 0.5)',
                      previewOnDrag: false,
                      previewQuality: 0.65,
                      resultQuality: 0.9,
                      resultMimeType: 'image/jpeg',
                      selectButtonLabel: 'Escolher imagem',
                      showPreview: false,
                      skin: 'light',
                      uploadData: {},
                      uploadTo: false
                    }"
                    @cropper-error="erroCorte($event)"
                    @cropper-saved="salvarCorte($event)"
                    @cropper-cancelled="cancelaCorte()"
                  ></vueAnkaCropper>
                </v-container>
              </v-layout>
              <v-card-actions>
                <v-container fill-height fluid pa-1 justify-center>
                  <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadComprovanteVacinal = false">Fechar</v-btn>
                </v-container>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import CpfValidate from '../../componentes/validators/rules/cpf'
  import QrcodeVue from 'qrcode.vue'
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  import vueAnkaCropper from 'vue-anka-cropper'
  export default {
    components: {
      Snackbar,
      QrcodeVue,
      Loading,
      vueAnkaCropper
    },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        mask: "###.###.###-##",
        user: {},
        eventoSelecionado: '',
        inscricao: {
          cod_incricao: '',
          nome: '',
          nomeCracha: '',
          cpf: '',
          infoVacina: '',
          eventoId: '',
          email: '',
          empresa: '',
          cargo: '',
          statusPagamento: '',
          arquivoComprovanteVacinal: '',
        },
        inscricaoDefault: {
          cod_incricao: '',
          nome: '',
          nomeCracha: '',
          cpf: '',
          infoVacina: '',
          eventoId: '',
          email: '',
          empresa: '',
          cargo: '',
          statusPagamento: '',
          arquivoComprovanteVacinal: '',
        },
        dialogCancelamento: false,
        dialog: false,
        qtdInscritos: 0,
        capacidadeEvento: 0,
        reserva: 0,
        sexo: ['MASCULINO', 'FEMININO'],
        tipo: ['MEMBRO', 'VISITANTE'],
        doses: [
          { value: '1Dose', text: "TOMEI A 1ª DOSE" },
          { value: '2Dose', text: "TOMEI A 2ª DOSE" },
          { value: '3Dose', text: "TOMEI A 3ª DOSE" },
          { value: '0Dose', text: "NÃO ME VACINEI" },
          { value: 'naoInformado', text: "PREFIRO NÃO INFORMAR" },
        ],
        eventos: [],
        isLoading: false,
        fullPage: true,
        jaExiste: false,
        codigoExistente: '',
        msgResultado: '',
        idInscricao: '',
        inscricaoLocalizada: false,
        uploadComprovanteVacinal: false,
      }
    },

    mounted: function () {
      this.carregaDados()
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      async carregaDados() {
        this.isLoading = true
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"620ba82e95397f64f664332e"},{"ativo":"true"}]}}`).then(res => {
          for (var key in res.data) {
            if (res.data.hasOwnProperty(key)) {
              if (moment(this.formatDateHora(res.data[key].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
                this.eventos.push(res.data[key])
                this.eventoId = res.data[key].id
              }
            }
          }
          this.eventos = this.eventos.sort(this.compare)
          this.isLoading = false
        })
      },

      async localizarInscricao() {
        var vm = this;
        if (this.inscricao.eventoId == '' || this.inscricao.cpf == '' || this.inscricao.email == '' || !CpfValidate(this.inscricao.cpf)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha os dados e tente novamente!", "ATENÇÃO")
        } else {
          try {
            this.isLoading = true
            this.inscricao.email = this.inscricao.email.replaceAll(/\s/g,'').toLowerCase()
            await axios.get(`${baseApiUrl}inscricoes?filter={"where":{"and":[{"email":"${this.inscricao.email}"},{"statusPagamento":{"inq":["PAGO","PENDENTE"]}}]}}`).then(response => {
              if (response.data) {
                if (response.data[0].statusPagamento == 'PENDENTE') {
                  this.inscricao.nome = response.data[0].nome
                  this.inscricao.nomeCracha = response.data[0].nomeCracha
                  this.inscricao.empresa = response.data[0].empresa
                  this.inscricao.cargo = response.data[0].cargo
                  this.inscricao.statusPagamento = response.data[0].statusPagamento
                  this.inscricao.id = response.data[0].id
                  this.inscricaoLocalizada = true
                  this.isLoading = false
                } else if (response.data[0].statusPagamento == 'PAGO') {
                  this.nomeEvento(response.data[0].eventoId)
                  this.inscricao.nome = response.data[0].nome
                  this.inscricao.cod_incricao = response.data[0].cod_incricao
                  this.isLoading = false
                  this.msgResultado = 'Inscrição confirmada com sucesso!'
                  this.dialog = true
                }
              } else {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
              }
            })
          } catch (error) {
            this.isLoading = false
            this.inscricaoLocalizada = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao localizar inscrição", "DESCULPE")
          }
        }
      },

      async nomeEvento(idEvento) {
        try {
          let response = await axios.get(`${baseApiUrl}Eventos/${idEvento}`)
          if (response.data) {
            this.eventoSelecionado = response.data.nome
          }
        } catch (error) {
          //
        }
      },

      formatDate(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null
        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateBrz(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHora(date) {
        if (!date) return null
        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      async solicitaCancelamento() {
        this.isLoading = true
        if (this.inscricao.nome == '' || this.inscricao.eventoId == '' || this.inscricao.cpf == '') {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha os campos: Evento, Nome e CPF para solicitar o cancelamento!", "ATENÇÃO")
        } else {
          this.isLoading = false
          this.dialogCancelamento = true
        }
      },

      async realizarCancelamento() {
        this.idInscricao = ''
        this.isLoading = true
        try {
          let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.inscricao.eventoId}"},{"cpf":"${this.inscricao.cpf}"}]}}`)
          if (res.data[0].id) {
            this.idInscricao = res.data[0].id
          } else {
            this.isLoading = false
            this.dialogCancelamento = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
          }
        } catch (error) {
          this.isLoading = false
          this.dialogCancelamento = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
        }
        if (this.idInscricao != '') {
          try {
            let res = await axios.delete(`${baseApiUrl}Inscricoes/${this.idInscricao}`)
            if (res.data != '') {
              this.isLoading = false
              this.inscricao = Object.assign({}, this.inscricaoDefault)
              this.dialogCancelamento = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1", "Cancelamento realizado com sucesso!", "INFORMAÇÃO")
            } else {
              this.isLoading = false
              this.dialogCancelamento = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
            }
          } catch (error) {
            this.isLoading = false
            this.dialogCancelamento = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
          }
        }
      },

      async realizarInscricao() {
        await this.carregaDados()
        this.isLoading = true
        this.jaExiste = false
        if (this.inscricao.eventoId == '' || this.inscricao.cpf == '' || this.inscricao.email == '' || this.inscricao.infoVacina == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.arquivoComprovanteVacinal == '') {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
        } else {
          for (var key in this.eventos) {
            if (this.eventos.hasOwnProperty(key)) {
              if (this.eventos[key].id == this.inscricao.eventoId) {
                this.capacidadeEvento = this.eventos[key].vagas
                this.eventoSelecionado = this.eventos[key].nome
                this.reserva = this.eventos[key].reserva
              }
            }
          }

          await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.inscricao.eventoId}`).then(res => {
            this.qtdInscritos = res.data.length + this.reserva
            if (res.data.length > 0) {
              for (var j = 0; j <= res.data.length - 1; j++) {
                if (res.data[j].cpf == this.inscricao.cpf) {
                  this.jaExiste = true
                  this.insricaoExistente = res.data[j]
                  this.codigoExistente = res.data[j].cod_incricao
                }
              }
            }
          })

          if (this.jaExiste) {
            this.msgResultado = 'Já existe um cadastro realizado para esse evento com o CPF informado'
            this.isLoading = false
            this.inscricao.cod_incricao = this.codigoExistente
            this.dialog = true
          } else if (this.qtdInscritos == this.capacidadeEvento && !this.jaExiste) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, a capacidade máxima para o evento selecionado foi atingida!", "INFORMAÇÃO")
          } else {
            this.inscricao.cod_incricao = new Date().getTime().toString().substr(8, 12)
            this.inscricao.statusPagamento = 'PAGO'
            await axios.post(`${baseApiUrl}inscricoes/salvaInscricao`, this.inscricao)
            .then(() => {
              this.isLoading = false
              this.msgResultado = 'Inscrição confirmada com sucesso!'
              this.dialog = true
              this.carregaDados()

            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar cadastro, tente novamente", "ERRO")
            })
          }
        }
      },

      closeDialog() {
        this.dialog = false
        this.inscricao = Object.assign({}, this.inscricaoDefault)
        this.$validator.reset()
      },

      compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const dataA = a.fim;
        const dataB = b.fim;

        let comparison = 0;
        if (dataA > dataB) {
          comparison = 1;
        } else if (dataA < dataB) {
          comparison = -1;
        }
        return comparison;
      },

      cancelaCorte() {
        this.uploadComprovanteVacinal = false
      },

      async salvarCorte(event) {
        this.isLoading = true
        this.inscricao.arquivoComprovanteVacinal = event.croppedImageURI
        this.uploadComprovanteVacinal = false
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#87F500","Imagem salva!","SUCESSO");
      },

      erroCorte (event) {
        if (event.substring(0,5) == "Wrong") {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Apenas imagens são permitidas!","ATENÇÃO");
        }
        else if (event.substring(0,4) == "File") {
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Arquivo muito grande. Máximo permitido de 8MB","ATENÇÃO");
        }
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #142c52, #92c1e1);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>
